import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetAllAccountLinksResponse extends BackendResponse {
  items: AccountLinkRow[];
}

export interface GetAllAccountLinksParameters extends NextApiParams {
  /** Optional: only return rows for this concern. */
  concernId?: number;
}

/** VPN-only debug endpoint: dumps every row in the legacy AccountLink table. */
export const getAllAccountLinks = withNextApi<
  GetAllAccountLinksResponse,
  GetAllAccountLinksParameters
>("/auth/GetAllAccountLinks", {
  method: "GET",
});

export interface AccountLinkRow {
  id: number;
  guid: string | null;
  candidateId: number;
  concernId: number;
  expirationTime: string | null;
  provider: string | null;
  /** AccountLink.Email — the idp-side email the link was created with. */
  idpEmail: string | null;
  /** The candidate's current email from alleaktivebrukere (null if no active candidate matches). */
  candidateEmail: string | null;
  createdAt: string | null;
  lastUsedAt: string | null;
}
